/**
 * Normalizes a value that may be a single item, an array of items, or undefined into an
 * array — `undefined` becomes an empty array, a single item becomes a one-item array, and
 * an array is returned as-is.
 */
export function ensureArray<T>(value: T | T[] | undefined): T[] {
  if (value === undefined) return [];
  return Array.isArray(value) ? value : [value];
}
